export default __webpack_public_path__ + "static/13-d8424b62943ad34c6c1156cb7559f1c1.jpg";